export const SET_LANGUAGE = '@@LANGUAGE/SET_LANGUAGE';

export const actionCreators = {
    setLanguage: (payload) => ({
        type: SET_LANGUAGE, 
        payload
    }),
}
